import type { LearnerProfile_EducationHistory as EducationHistory } from '__generated__/graphql-types-do-not-use';

const shouldShowHighlightsEducationTag = (educationHistory: EducationHistory[] | undefined) => {
  if (!educationHistory?.length) return false;

  const latestEducation = educationHistory?.[0];

  return !!latestEducation && !!latestEducation.graduationDate && !!latestEducation.isCurrentlyAStudent;
};

export default shouldShowHighlightsEducationTag;
